import { render, staticRenderFns } from "./NotebookMenuSwitcher.vue?vue&type=template&id=72bba702&"
import script from "./NotebookMenuSwitcher.vue?vue&type=script&lang=js&"
export * from "./NotebookMenuSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports